// @flow
'use strict';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';

import FormExportacaoCte from './form_exportacao_cte';
import { onSubmitForm } from '../functions';

import { rootSelector } from '../../../../../../reducers/lista_documentos/cte';
import { openModalSelector } from '../../../../../../reducers/modal_exportacao_lista';

export default compose(
    connect<*, *, *, *, *, *>(createStructuredSelector({
      open: openModalSelector,
      initialValues: rootSelector,
    })),
    reduxForm({
      form: 'listaDocumentosCte', enableReinitialize: true,
      onSubmit: onSubmitForm,
    }),
)(FormExportacaoCte);